import { Layout } from "antd";
import "antd/dist/reset.css";
import { BrowserRouter } from "react-router-dom";
import HeaderApp from "./components/Component-HeaderApp";
import SideNav from "./components/Component-SideNav";
import "./css/App.css";
import RoutePath from "./utils/RoutePath";

const { Content } = Layout;

const App = (): JSX.Element => {

  return (
    <BrowserRouter>
      <Layout
        className="default-theme"
        style={{ height: "100%", minHeight: "100vh" }}
      >
        <SideNav />
        <Layout>
          <HeaderApp />
          <Content className="content">
            <RoutePath />
          </Content>
        </Layout>
      </Layout>
    </BrowserRouter>
  );
};

export default App;
